import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.css']
})
export class TestimonialComponent implements OnInit {
  testHTML: string;
  constructor(private eventEmitterService: EventEmitterService) {
    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateTestHTML(res));
   }

  ngOnInit(): void {
  }

  updateTestHTML(res: string)
  {
    this.testHTML = res;
  }

}
